import { InfoTip } from "./InfoTip";

export const StatCard = ({ label, value, note, tip, testId, delay = 0 }) => (
  <div className="rise rounded-xl border border-amber-700/15 bg-white p-5 sm:p-6 shadow-[0_1px_0_rgba(120,53,15,0.06)]"
    style={{ animationDelay: `${delay}ms` }} data-testid={testId}>
    <div className="flex items-start justify-between gap-2">
      <p className="text-xs uppercase tracking-widest font-semibold text-amber-800/80">{label}</p>
      {tip && <InfoTip text={tip} testId={`${testId}-tip`} />}
    </div>
    <p className="mt-3 font-serif-display text-4xl font-bold text-amber-950" data-testid={`${testId}-value`}>
      {value === null || value === undefined ? <span className="text-xl text-stone-400">No data</span> : value.toLocaleString()}
    </p>
    {note && <p className="mt-2 text-xs text-stone-500">{note}</p>}
  </div>
);
